module.exports = __webpack_public_path__ + "static/media/introductory_image2.59196193.svg";